import styled, { css } from "styled-components";

export const Content = styled.section`
  display: flex;
  flex-direction: column;
`;

export const ModalDescription = styled.span`
  color: ${(props) => props.theme.newColors["gray-900"]};

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    margin-bottom: 1rem;
    font-size: ${(props) => props.theme.fontSize.XXS};
  }
`;

export const SubTitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  font-size: ${(props) => props.theme.fontSize.XS};
  color: ${(props) => props.theme.colors["gray-950"]};

  margin-bottom: 1.5rem;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    flex-direction: column;
    justify-content: center;
    align-items: normal;
    margin-bottom: 1rem;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  button {
    display: flex;
    align-items: center;
    justify-content: center;

    border: none;
    background-color: transparent;
  }
`;

export const Title = styled.span`
  font-size: ${(props) => props.theme.fontSize.XS};
  font-weight: ${(props) => props.theme.fontWeight.Semibold};
  color: ${(props) => props.theme.newColors["gray-900"]};
`;

export const SelectAllButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  background-color: transparent;
  border: none;

  padding: 0.5rem 0.75rem;
  border-radius: ${(props) => props.theme.borderRadius.SM};
  border: 1px solid ${(props) => props.theme.colors["gray-600"]};

  height: 2rem;

  span {
    height: 1.1rem;
    color: ${(props) => props.theme.newColors["gray-900"]};
  }

  &:hover {
    box-shadow: 0px 2px 5px 0px rgba(37, 30, 30, 0.25);
    transition: all 0.2s;
  }

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    height: 2.5rem;
  }
`;

interface PermissionsContentProps {
  permissionsLoading: boolean;
}

export const PermissionsContent = styled.div<PermissionsContentProps>`
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  gap: 1rem;

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.colors["gray-600"]};
    border-radius: 4px;
  }

  ::-webkit-scrollbar-track {
    background-color: ${(props) => props.theme.colors["gray-400"]};
    border-radius: 4px;
  }

  ${(props) =>
    props.permissionsLoading &&
    css`
      align-items: center;
      justify-content: center;
    `};
`;

export const PermissionsWrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  overflow-y: auto;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    gap: 0rem;
    max-height: 60vh;
  }
`;

export const PermissionType = styled.h4`
  font-weight: ${(props) => props.theme.fontWeight.Semibold};
  color: ${(props) => props.theme.newColors["gray-900"]};

  margin-bottom: 0.75rem;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    margin-bottom: 0.5rem;
  }
`;

export const PermissionsViewControl = styled.li`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    flex-direction: column;
  }
`;

export const ResponsiveButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;

  button {
    height: 2.5rem;
    width: 100%;
  }
`;

interface MessageProps {
  error: boolean;
}

export const Message = styled.span<MessageProps>`
  text-align: center;
  margin-top: 4px;
  font-weight: ${(props) => props.theme.fontWeight.Semibold};

  color: ${(props) => props.theme.colors["green-800"]};

  ${(props) =>
    props.error &&
    css`
      color: ${props.theme.colors["red-500"]};
    `};
`;

export const PermissionPage = styled.h4`
  font-size: ${(props) => props.theme.fontSize.XS};
  font-weight: ${(props) => props.theme.fontWeight.Bold};
  color: ${(props) => props.theme.colors["gray-950"]};

  margin-bottom: 0.75rem;
`;

export const PermissionsList = styled.ul`
  list-style: none;

  display: flex;
  flex-direction: column;
  gap: 0.75rem;

  padding-bottom: 1.5rem;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    gap: 0.5rem;
  }

  & > li {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;

    @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
      gap: 0.5rem;
    }
  }
`;

export const PermissionItem = styled.button`
  display: flex;
  gap: 0.75rem;
  align-items: center;
  background-color: transparent;
  border: none;

  label {
    font-size: ${(props) => props.theme.fontSize.XXXS};
    color: ${(props) => props.theme.newColors["gray-900"]};
    cursor: pointer;
  }

  input:disabled {
    cursor: not-allowed;
  }

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    height: 2.5rem;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ExpandGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-left: 2.75rem;

  & > button:nth-child(2) {
    margin-left: 1.25rem;
  }

  & > button:nth-child(3) {
    margin-left: 2.5rem;
  }
`;
